import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { AddOffersPage } from '@/areas/offers/PdfOfferImporter/pages/AddOffersPage';
import { canAddOffers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/offers/create')({
    staticData: {
        access: { permissions: canAddOffers },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: stringSearch({
        sourcingLineItemId: 'optional',
        rfqId: 'optional',
        partId: 'optional',
        partType: 'optional',
        quoteRequestId: 'optional',
        defaultOfferType: 'optional',
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const sourcingLineItemId = Route.useSearch({ select: (search) => search.sourcingLineItemId });
    const rfqId = Route.useSearch({ select: (search) => search.rfqId });
    const partId = Route.useSearch({ select: (search) => search.partId });
    const partType = Route.useSearch({ select: (search) => search.partType });
    const quoteRequestId = Route.useSearch({ select: (search) => search.quoteRequestId });
    const defaultOfferType = Route.useSearch({ select: (search) => search.defaultOfferType });
    return (
        <AddOffersPage
            sourcingLineItemId={sourcingLineItemId}
            rfqId={rfqId}
            partId={partId}
            partType={partType}
            quoteRequestId={quoteRequestId}
            defaultOfferType={defaultOfferType}
        />
    );
}
